import { useMemo, useRef, useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './Edit.less';
import { EditProvider } from '@/context/EditContext';
import { useEditGlobal } from './state/EditGlobal';
import useComputedSize from './state/computedSize';
import EditPopState from './state/popup';
import { usePupData } from './state/pupData';
import { useWebSocket } from '@/hooks/useWebSocket.js';
import PopUp from '@/components/popup/PopUp';
import Icon from '@/components/iconfont/Icon';
// 导入头部组件
import Header from '@/pages/edit/components/header/Header';
// 导入编辑标签页组件
import EditTab from '@/pages/edit/components/editTab/EditTab.jsx';
// 导入句子组件
import Speech from '@/pages/edit/components/speech/Speech.jsx';
// 导入字幕组件
import Subtitle from '@/pages/edit/components/subtitle/Subtitle.jsx';
// 导入视频组件
import VideoEditor from '@/pages/edit/components/videoEditor/VideoEditor.jsx';
// 导入视频样式组件
import Style from '@/pages/edit/components/style/Style.jsx';

import SubtitleStyle from '@/pages/edit/components/subtitleStyle/Style.jsx';

import VoicePopUp from '@/pages/edit/components/voicePopUp/VoicePopUp';
import PopUpGlobal from '@/pages/edit/components/popupGlobal/popupGlobal.jsx';
import TimelineBusiness from '@/components/Timeline/Timeline.tsx';
import { infoController, userService } from '@/api/index';
import { projectController } from '@/api/edit';
import { globalController } from '@/api';

import Layouticon1 from '@/assets/edit/layoutIcon/layouticon1.svg';
import Layouticon2 from '@/assets/edit/layoutIcon/layouticon2.svg';
import Layouticon3 from '@/assets/edit/layoutIcon/layouticon3.svg';
import Layouticon4 from '@/assets/edit/layoutIcon/layouticon4.svg';
import Layouticon5 from '@/assets/edit/layoutIcon/layouticon5.svg';
import Layouticon6 from '@/assets/edit/layoutIcon/layouticon6.svg';
import Layouticon7 from '@/assets/edit/layoutIcon/layouticon7.svg';
import Layouticon8 from '@/assets/edit/layoutIcon/layouticon8.svg';
import Layouticon9 from '@/assets/edit/layoutIcon/layouticon9.svg';
import Layouticon10 from '@/assets/edit/layoutIcon/layouticon10.svg';
import Layouticon11 from '@/assets/edit/layoutIcon/layouticon11.svg';
import Layouticon12 from '@/assets/edit/layoutIcon/layouticon12.svg';
import Originalicon from '@/assets/edit/layoutIcon/originalicon.svg';
import editLoading from '@/assets/edit/editLoading.gif';
const layoutIcons = {
  1: Layouticon1,
  2: Layouticon2,
  3: Layouticon3,
  4: Layouticon4,
  5: Layouticon5,
  6: Layouticon6,
  7: Layouticon7,
  8: Layouticon8,
  9: Layouticon9,
  10: Layouticon10,
  11: Layouticon11,
  12: Layouticon12,
};
import { useTranslation } from 'react-i18next';
import { fullDownloadAudio, fullDownloadBGM } from '@/components/Timeline/utils.ts';
import { ProjectMode } from '@/interface.ts';
// import {
//   setOriginalSubtitleRestructure,
//   setBilingualSubtitleRestructure,
//   setTranslationTTSRestructure,
// } from '@/pages/edit/utils/subtitleSegmentation';
export default function Edit() {
  const { t } = useTranslation();
  const editContextValue = useEditGlobal();
  const popContextValue = EditPopState();
  const editpupData = usePupData();
  const navigate = useNavigate();
  const getTimelineController = useRef(null);
  const [playState, setPlayState] = useState(false);
  const {
    scaleRatio,
    bgDesignWH,
    updateElementSize,
    selectedAspectRatio,
    setSelectedAspectRatio,
    dimensions,
    setDimensions,
  } = useComputedSize();
  const mainRef = useRef(null);
  const timelineRef = useRef(null);
  const [bottomHeight, setBottomHeight] = useState(230); // 底部默认高度
  const [isDragging, setIsDragging] = useState(false);
  const dragHandleRef = useRef(null);
  const containerRef = useRef(null);
  const [showLayoutBg, setShowLayoutBg] = useState('');

  useEffect(() => {
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    if (!projectItem) {
      navigate('/home');
      return;
    }
    editContextValue.setEditPageLoading(true);
    getProjectDetail();
  }, []);
  // useEffect(() => {
  //   setOriginalSubtitleRestructure();
  // }, []);

  useEffect(() => {
    if (editContextValue.projectDetail.backgroundId >= 0) {
      const bg = JSON.parse(sessionStorage.getItem('presetData')).backgrounds.find(
        (item) => item.id === editContextValue.projectDetail.backgroundId,
      );
      if (bg) editContextValue.setBgItem(bg);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editContextValue.presetData?.backgrounds, editContextValue.projectDetail?.backgroundId]);
  useWebSocket(
    'RETRY_SUCCESS',
    useCallback(async () => {
      try {
        const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
        const res = await projectController.detail({
          projectId: projectItem.id,
        });
        if (res.code === 0) {
          editContextValue.setProjectDetail(res.data.projectDetail);
        }
        console.log(res);
      } catch (error) {
        console.log(error);
      }
    }, []),
  );

  const getProjectDetail = async () => {
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    try {
      const presetDetail = await globalController.preset();
      if (presetDetail.code === 0) {
        sessionStorage.setItem('presetData', JSON.stringify(presetDetail.data));
      }
      const userDetail = await userService.userDetail();
      if (userDetail.code === 0) {
        editContextValue.setUserDetail(userDetail.data);
      }
      const priceList = await infoController.pointConsume();
      if (priceList.code === 0) {
        editContextValue.setpriceList(priceList.data);
      }

      const res = await projectController.session({ projectId: projectItem.id });
      if (res.code === 0) {
        editContextValue.setSessionId(res.data.sessionId);
        editContextValue.setProjectDetail(res.data.projectDetail);
        editContextValue.setDiyContentStyle(res.data.projectDetail.style.contentStyle);
        editContextValue.setIsTranslated(res.data.projectDetail.usage);
        editContextValue.setUseTranslate(res.data.projectDetail.useTranslate);
        editContextValue.setSubtitleShow(res.data.projectDetail.subtitleShow);
        editContextValue.setTranslationLanguage(res.data.projectDetail.translationLanguage);
        editContextValue.setSubtitleBox(res.data.projectDetail.subtitleBox);
        editContextValue.setTranslationSubtitleBox(res.data.projectDetail.translationSubtitleBox);
        editContextValue.setBilingualismSubtitleBox(res.data.projectDetail.bilingualismSubtitleBox);
        editContextValue.setCaptionsId(res.data.projectDetail.subtitleStyleId);
        editContextValue.setNewcaptionsId(res.data.projectDetail.bilingualismSubtitleStyleId);
        editContextValue.setSpeakerList(res.data.projectDetail.speakers);
        editContextValue.setMode(res.data.projectDetail.mode);
        editContextValue.setPresetData(JSON.parse(sessionStorage.getItem('presetData')));
        editContextValue.setSubtitleSegmentationCount(res.data.projectDetail.charNumber);
        editContextValue.setFontSizeBox(res.data.projectDetail.fontSizeBox);
        editContextValue.setDoubleFontSizeBox(res.data.projectDetail.doubleFontSizeBox);
        setSelectedAspectRatio(res.data.projectDetail.aspectType);
        setDimensions(res.data.projectDetail.dimensions || { width: 1920, height: 1080 });
        // 抽出不同类型数据
        const videoMaterial = filterDataByType(res.data.projectDetail.materials, 0);
        const sentenceMaterial = filterDataByType(res.data.projectDetail.materials, 1);
        const musicMaterial = filterDataByType(res.data.projectDetail.materials, 2);
        const translationMaterial = filterDataByType(res.data.projectDetail.materials, 4);
        // 对不同类型数据进行排序
        if (videoMaterial) {
          videoMaterial.details = editContextValue.sortByTimeLineFrom(videoMaterial.details);
          editContextValue.setVideoMaterial(videoMaterial);
        }
        // 过滤掉原文sentenceShow为false的数据
        if (sentenceMaterial) {
          sentenceMaterial.oriUrl = sentenceMaterial.oriUrl?.replace(
            'talecast.ai',
            'addsubtitle.ai',
          );
          sentenceMaterial.details = editContextValue.sortByTimeLineFrom(sentenceMaterial.details);
          const filteredSentences = sentenceMaterial.details.filter(
            (sentence) => sentence.sentenceShow !== false,
          );
          filteredSentences.filter((item) => {
            item.sentence = item.sentence?.replace(/\[__SPACE__\]/g, '');
            item.subtitle.text = item.subtitle.text?.replace(/\[__SPACE__\]/g, '');
            item.sentenceUrl = item.sentenceUrl?.replace('talecast.ai', 'addsubtitle.ai');
          });

          // if (sentenceMaterial.details[0].subtitleSegmented.length === 0) {
          // if (
          //   res.data.projectDetail.mode !== 'translation_and_tts' &&
          //   res.data.projectDetail.mode !== 'translation' &&
          //   res.data.projectDetail.mode !== 'add_subtitle_and_translation'
          // ) {
          //   sentenceMaterial.details = setOriginalSubtitleRestructure(
          //     filteredSentences,
          //     res.data.projectDetail.charNumber,
          //     res.data.projectDetail.language,
          //   );
          // }
          // }
          sentenceMaterial.details = filteredSentences;
          console.log(filteredSentences, '查看 原文');
          editContextValue.setSentenceMaterial(sentenceMaterial);
        }
        if (musicMaterial) {
          musicMaterial.oriUrl = musicMaterial.oriUrl?.replace('talecast.ai', 'addsubtitle.ai');
          musicMaterial.details = editContextValue.sortByTimeLineFrom(musicMaterial.details);
          musicMaterial.details.filter((item) => {
            item.url = item.url?.replace('talecast.ai', 'addsubtitle.ai');
          });
          editContextValue.setMusicMaterial(musicMaterial);
        }
        // 过滤掉译文sentenceShow为false的数据
        if (translationMaterial) {
          translationMaterial.oriUrl = translationMaterial.oriUrl?.replace(
            'talecast.ai',
            'addsubtitle.ai',
          );
          translationMaterial.details = editContextValue.sortByTimeLineFrom(
            translationMaterial.details,
          );
          const filteredSentences = translationMaterial.details.filter(
            (sentence) => sentence.sentenceShow !== false,
          );
          filteredSentences.filter((item) => {
            item.sentence = item?.sentence?.replace(/\[__SPACE__\]/g, '');
            item.subtitle.text = item?.subtitle.text?.replace(/\[__SPACE__\]/g, '');
            item.sentenceUrl = item.sentenceUrl?.replace('talecast.ai', 'addsubtitle.ai');
          });
          // if (translationMaterial.details[0].subtitleSegmented.length === 0) {
          // if (res.data.projectDetail.mode === 'translation_and_tts') {
          //   const { original, bilingual } = setTranslationTTSRestructure(
          //     sentenceMaterial.details,
          //     filteredSentences,
          //     res.data.projectDetail.charNumber,
          //     res.data.projectDetail.language,
          //     res.data.projectDetail.translationLanguage,
          //   );
          //   translationMaterial.details = bilingual;
          //   sentenceMaterial.details = original;
          //   editContextValue.setSentenceMaterial(sentenceMaterial);
          // } else {
          //   const { original, bilingual } = setBilingualSubtitleRestructure(
          //     sentenceMaterial.details,
          //     filteredSentences,
          //     res.data.projectDetail.charNumber,
          //     res.data.projectDetail.language,
          //     res.data.projectDetail.translationLanguage,
          //   );
          //   translationMaterial.details = bilingual;
          //   sentenceMaterial.details = original;
          //   editContextValue.setSentenceMaterial(sentenceMaterial);
          // }
          // }
          console.log(filteredSentences, '查看 译文');
          translationMaterial.details = filteredSentences;
          editContextValue.setTranslationMaterial(translationMaterial);
        }
        if (res.data.projectDetail.mode === ProjectMode.TRANSLATION_TTS) {
          setBottomHeight(256);
        }

        if (sentenceMaterial) {
          // await preloadAudio(sentenceMaterial);
          await fullDownloadAudio(sentenceMaterial); // 全量下载
        }
        if (translationMaterial) {
          // await preloadAudio(translationMaterial);
          await fullDownloadAudio(translationMaterial); // 全量下载
        }
        if (musicMaterial) {
          await fullDownloadBGM(musicMaterial);
        }
        editContextValue.setMaterialSorted(true);
      }
    } catch (error) {
      console.log(error, 'error');
      if (typeof error === 'object') {
        const err = error; // 直接使用error对象
        if (err.code === -33) {
          navigate('/home');
        }
      }
      editContextValue.setEditPageLoading(false);
    }
  };
  // 查找数据
  const filterDataByType = (dataArray, type) => {
    return dataArray.find((item) => item.type === type);
  };

  // 修改拖拽处理函数
  const handleDragStart = (e) => {
    e.preventDefault();
    setIsDragging(true);

    // 立即添加事件监听器
    document.addEventListener('mousemove', handleDrag);
    document.addEventListener('mouseup', handleDragEnd);
  };

  // 鼠标拖拽
  const handleDrag = (e) => {
    if (!containerRef.current) return;

    const containerRect = containerRef.current.getBoundingClientRect();
    const mainMinHeight = 245; // main最小高度
    const bottomMinHeight = 150; // 底部最小高度

    // 计算相对于容器底部的位置，以确定底部高度
    const relativeY = containerRect.bottom - e.clientY;

    // 确保不小于最小高度
    let newBottomHeight = Math.max(relativeY, bottomMinHeight);

    // 确保main区域不小于最小高度
    const containerHeight = containerRect.height;
    const headerHeight = 60;
    const maxBottomHeight = containerHeight - headerHeight - mainMinHeight;
    newBottomHeight = Math.min(newBottomHeight, maxBottomHeight);

    setBottomHeight(newBottomHeight);
    updateElementSize();
  };

  const handleDragEnd = () => {
    setIsDragging(false);
    document.removeEventListener('mousemove', handleDrag);
    document.removeEventListener('mouseup', handleDragEnd);
  };

  // 确保在组件卸载时清理事件监听器
  useEffect(() => {
    return () => {
      document.removeEventListener('mousemove', handleDrag);
      document.removeEventListener('mouseup', handleDragEnd);
    };
  }, []); // 这里不依赖isDragging，避免重新添加移除事件监听器

  // 使用 useMemo 来计算容器样式
  const memoizedContainerStyle = useMemo(() => {
    return {
      transform: `scale(${scaleRatio}) translate(-50%,-50%)`,
      width: bgDesignWH.w + 'px',
      height: bgDesignWH.h + 'px',
      borderRadius: 10 / scaleRatio + 'px',
    };
  }, [scaleRatio, bgDesignWH]);

  // 全局点击事件监听
  useEffect(() => {
    // 全局点击事件分发
    const handleClickOutside = (event) => {
      editContextValue.setClickOutsideListener(event);
      if (!event.target.closest('.layout_bg_box') && !event.target.closest('.layout_bg_list')) {
        setShowLayoutBg('');
      }
    };
    // 添加事件监听
    document.addEventListener('mousedown', handleClickOutside);

    // 清理事件监听
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleShowLayoutBg = (val) => {
    setShowLayoutBg(val);
  };

  const handleChangeBackground = async (val) => {
    editContextValue.setProjectDetail((prev) => ({ ...prev, backgroundId: val.id }));
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    try {
      const res = await projectController.background({
        projectId: projectItem.id,
        body: {
          backgroundId: val.id,
          sessionId: editContextValue.sessionId,
        },
      });
      console.log(res);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangeLayout = (val, index) => {
    window.onClickGATrackEvent('ratio-change', {
      ratio: val.aspectRatioId,
    });
    setSelectedAspectRatio(val.aspectRatioId);
    editContextValue.setProjectDetail((prev) => ({
      ...prev,
      aspectType: val.aspectRatioId,
      layoutIndex: index,
    }));
    setShowLayoutBg('');
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    try {
      projectController.layoutIndex({
        projectId: projectItem.id,
        body: {
          layoutIndex: index,
          aspectType: val.aspectRatioId,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <EditProvider
      value={{
        ...editContextValue,
        ...editpupData,
        ...popContextValue,
        selectedAspectRatio,
        setSelectedAspectRatio,
        dimensions,
        setDimensions,
        scaleRatio,
      }}>
      {editContextValue.editPageLoading && (
        <div className="loading_box">
          <img src={editLoading} className="editLoadingImg" />
          <span className="editLoadingTitle">{t('As_Edit_BrandSlogan')}</span>
        </div>
      )}
      <div className={`edit_box ${isDragging && 'move_cursor'}`} ref={containerRef}>
        {/* <div className="edit_header">
          <Header />
        </div> */}
        <div className="edit_main" ref={mainRef}>
          <div className="edit_left">
            <div className="edit_tab">
              {/* 标签内容 */}
              <EditTab />
            </div>
            <div className="edit_sentence">
              {editContextValue.mode !== 'add_subtitle_and_translation' &&
                editContextValue.mode !== 'add_subtitle' &&
                editContextValue.mode !== 'translation' && (
                  <div
                    className="edit_item"
                    style={{ display: editContextValue.activeTab === 'speech' ? 'block' : 'none' }}>
                    {/* 句子内容 */}
                    <Speech
                      playState={playState}
                      getTimelineController={getTimelineController.current}
                    />
                  </div>
                )}

              <div
                className="edit_item"
                style={{ display: editContextValue.activeTab === 'subtitle' ? 'block' : 'none' }}>
                {/* 字幕内容 */}
                <Subtitle />
              </div>
              <div
                className="edit_item"
                style={{
                  display: editContextValue.activeTab === 'subtitleStyle' ? 'block' : 'none',
                }}>
                {/* 字幕内容 */}
                <SubtitleStyle />
              </div>

              <div
                className="edit_item"
                style={{ display: editContextValue.activeTab === 'media' ? 'block' : 'none' }}>
                {/* 样式内容 */}
                <Style />
              </div>
            </div>
          </div>

          <div className="edit_right">
            <div className="edit_right_box">
              <Header />
            </div>
            <div className="edit_video">
              <div className="edit_video_main" id="rightvideoId">
                <div className="edit_video_box" style={memoizedContainerStyle}>
                  {/* 视频编辑器内容 */}
                  <VideoEditor />
                  <div className="layout_bg_box" style={{ '--scaleRatio': 1 / scaleRatio }}>
                    <div className="layout_bg_main">
                      <div
                        className={`layout_bg_item layout_bg_item1 ${showLayoutBg === 'layout' && 'active_layout_bg_item'}`}
                        onClick={() => {
                          window.onClickGATrackEvent('ratio-click');
                          handleShowLayoutBg('layout');
                        }}>
                        <Icon name="icon-Ratio" />
                        <span>{t('As_Edit_Frameeditchoice1')}</span>
                      </div>
                      <div
                        className={`layout_bg_item layout_bg_item2 ${showLayoutBg === 'bg' && 'active_layout_bg_item'}`}
                        onClick={() => {
                          window.onClickGATrackEvent('background-click');
                          handleShowLayoutBg('bg');
                        }}>
                        <Icon name="icon-Background" />
                        <span>{t('As_Edit_Frameeditchoice2')}</span>
                      </div>
                      {showLayoutBg && (
                        <div
                          className="layout_bg_list"
                          style={{
                            width:
                              showLayoutBg === 'bg'
                                ? '266px'
                                : showLayoutBg === 'layout'
                                  ? '236px'
                                  : '0',
                            bottom:
                              showLayoutBg === 'bg'
                                ? '35px'
                                : showLayoutBg === 'layout'
                                  ? '35px'
                                  : '0',
                          }}>
                          {showLayoutBg === 'layout' && (
                            <div className="layout_list">
                              <div
                                className="layout_originalicon"
                                onClick={() => {
                                  handleChangeLayout({ aspectRatioId: 3 }, -1);
                                }}>
                                <div className="layout_list_item_left">
                                  <img src={Originalicon} alt="" />
                                  <div>
                                    <span>{t('As_Edit_BgOriginalRatio')}</span>
                                  </div>
                                </div>
                                {editContextValue.projectDetail?.layoutIndex === -1 && (
                                  <Icon
                                    name="icon-Generate-speech"
                                    className="layout_list_item_icon"
                                  />
                                )}
                              </div>
                              <div className="layout_line"></div>
                              {editContextValue.layoutList.map((layoutItem, index) => (
                                <div
                                  key={index}
                                  className="layout_list_item"
                                  onClick={() => {
                                    handleChangeLayout(layoutItem, index);
                                  }}>
                                  <div className="layout_list_item_left">
                                    <img src={layoutIcons[index + 1]} alt="" />
                                    <div>
                                      <span>{t(layoutItem.title)}</span>
                                      <span>{layoutItem.aspectRatio}</span>
                                    </div>
                                  </div>
                                  {editContextValue.projectDetail?.layoutIndex === index && (
                                    <Icon
                                      name="icon-Generate-speech"
                                      className="layout_list_item_icon"
                                    />
                                  )}
                                </div>
                              ))}
                            </div>
                          )}
                          {showLayoutBg === 'bg' && (
                            <div className="bg_list_box">
                              <div className="bg_list">
                                {editContextValue.presetData?.backgrounds?.map((bgItem, index) => (
                                  <div
                                    key={index}
                                    className={`bg_list_item ${editContextValue.projectDetail.backgroundId === bgItem.id && 'active_bg_list_item'}`}
                                    onClick={() => {
                                      handleChangeBackground(bgItem);
                                    }}>
                                    <img src={bgItem.previewImgUrl} alt="" />
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="edit_timeline" ref={timelineRef} style={{ height: `${bottomHeight}px` }}>
          {/* 在顶部添加可拖动的手柄 */}
          <div
            className={`drag_handle ${isDragging && 'dragging'}`}
            ref={dragHandleRef}
            onMouseDown={handleDragStart}></div>
          {/* 时间轴内容 */}
          <TimelineBusiness
            getTempAudioController={(fn) => {
              getTimelineController.current = fn;
            }}
            onPlayStateChange={(state) => setPlayState(state)}></TimelineBusiness>
        </div>
      </div>
      <VoicePopUp />
      <PopUp />
      <PopUpGlobal />
    </EditProvider>
  );
}
